<template>
  <div class="training-videos-sections">

    <div class="page-subtitle">
      Sections
    </div>

    <table class="table table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="section in sections">
          <td>{{section.id}}</td>
          <td>
            <input type="text"
                   placeholder="Section name"
                   class="form-control"
                   @blur="save"
                   v-model="section.section"/>
          </td>
          <td>
            <div class="actions">
              <button class="button action remove"
                      type="button"
                      @click="remove(index)">
                <ion-icon name="remove-circle-outline"></ion-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">
            <button class="btn btn-success"
                    type="button"
                    @click="add">
              Add section
            </button>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "TrainingVideosSectionsEditor",
  data(){
    return {
      loading: false,
      sections: []
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    get(){
      axios.get('/videos/sections').then((r) => {
        this.sections = r.data
        this.$emit('sections', r.data)
      })
    },
    add(){
      this.sections.push({
        id: 0,
        section: ''
      })
    },
    remove(index){
      let item = this.sections[index]

      if(!item.name){
        return this.sections.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this section?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.sections.splice(index, 1)
              this.save()
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
    save(){
      axios.post('/videos/sections', {
        sections: this.sections
      }).then((r) => {
        this.sections = r.data
        this.$emit('sections', this.sections)
      })
    }
  }
}
</script>

<style scoped>

</style>
